import { getDisplayableSessionGist } from '@/constants/session_summary';
import { resolvePatientName } from '@/features/sessions/components/session-list/patient-cell.utils';
import type { SessionListItem } from '@/features/sessions/types';
import type { IntlShape } from 'react-intl';
import { navV3Messages } from '../nav-v3.messages';

export interface RecentVisitLabelParts {
  /** Session name, or untitled fallback — never a timestamp. */
  primary: string;
  /** Resolved patient name for the avatar marker, when available. */
  patientName: string | undefined;
}

export function getRecentVisitPrimaryLabel(
  session: Pick<SessionListItem, 'session_name'>,
  intl: IntlShape
): string {
  return (
    getDisplayableSessionGist(session.session_name) ??
    intl.formatMessage(navV3Messages.untitledSession)
  );
}

/**
 * Computes the label `RecentVisitRow` uses for its top-level text and the
 * patient-backed type marker.
 */
export function getRecentVisitLabelParts(
  session: SessionListItem,
  intl: IntlShape
): RecentVisitLabelParts {
  const patientName = resolvePatientName(session);
  const primary = getRecentVisitPrimaryLabel(session, intl);

  return { primary, patientName };
}
